export interface ILegendColorStackItem {
    id: string;
    visible: boolean;
    color: string;
}

export interface ILegendToggleVisibleRef {
    id: string;
}

export interface IApplyLegendToggleWithColorStackOptions {
    acquire: () => string | undefined;
    release: (color: string) => void;
    hiddenSeriesColor: string;
}

export function applyLegendToggleWithColorStack<T extends ILegendColorStackItem>(
    prevItems: T[],
    visibleLegendItems: ILegendToggleVisibleRef[],
    { acquire, release, hiddenSeriesColor }: IApplyLegendToggleWithColorStackOptions,
): T[] {
    const visibleById = visibleLegendItems.reduce(
        (acc, item) => {
            acc[item.id] = true;
            return acc;
        },
        {} as Record<string, boolean>,
    );

    return prevItems.map((item) => {
        const nextVisible = Boolean(visibleById[item.id]);
        if (item.visible === nextVisible) {
            return item;
        }
        //was not visible, now is
        if (nextVisible) {
            const newColor = acquire();
            return {
                ...item,
                visible: true,
                color: newColor ?? item.color,
            };
        }
        //was visible, now is not
        if (item.color !== hiddenSeriesColor) {
            release(item.color);
        }
        return {
            ...item,
            visible: false,
            color: hiddenSeriesColor,
        };
    });
}
